import React from 'react';
import {
  ReferenceManyField,
  TextField,
  Labeled,
  Datagrid,
  ReferenceField,
} from 'react-admin';

import '../styles.css';
import DatagridJSONField from '../../General/DatagridJSONField';

const DriverLicenseURL = ({ record }) => (record.url ?
  <a href={record.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.875rem' }}>View Driver&#39;s License</a> :
  <span className="normalField">Not Uploaded.</span>);

const DriversLicense = ({ data, ids, loadedOnce }) => {
  if (!loadedOnce) {
    return null;
  }
  const record = data[ids[0]];
  return record && record.driverLicenseUploadedAt ? (
    <ReferenceField basePath="/users" record={record} source="userId" reference="userFiles" linkType={false}>
      <DriverLicenseURL />
    </ReferenceField>
  ) : <span className="normalField">Not Uploaded.</span>;
};

export default ({ record }) => (
  <table style={{ width: '100%' }}>
    <tbody>
      <tr>
        <td>
          <Labeled label="Driver's License">
            <ReferenceManyField label="Accounts" basePath="/accounts" reference="accounts" target="userId" source="id" record={record}>
              <DriversLicense />
            </ReferenceManyField>
          </Labeled>
        </td>
      </tr>
      <tr>
        <td>
          <Labeled label="User Actions">
            <ReferenceManyField basePath="/accounts" reference="userActions" target="userId" source="id" record={record} linkType={false}>
              <Datagrid>
                <TextField source="type" label="Action Type" />
                <TextField source="createdAt" label="Created At" />
                <TextField source="updatedAt" label="Updated At" />
                <DatagridJSONField source="metadata" label="Metadata" />
              </Datagrid>
            </ReferenceManyField>
          </Labeled>
        </td>
      </tr>
    </tbody>
  </table>
);



// WEBPACK FOOTER //
// ./src/components/User/children/UserHistoryAndDocs_Show.jsx